export enum CouleursEnum {
  success = "Vert",
  warning = "Orange",
  danger = "Rouge",
  secondary = "Gris",
  info = "Bleu",
  customPurple = "Violet"
}